if (!customElements.get('shipping-calculator-cart-brazil')) {
  class ShippingCalculatorCartBrazil extends HTMLElement {
    constructor() {
      super();
      this.zip = this.querySelector('.js-zip-input');
      this.button = this.querySelector('button');
      
      this.setupEventListeners();
      this.setupZipMask();
    }

    init() {
      this.country = this.querySelector('.js-country-select');
      this.province = this.querySelector('.js-province-select');
      this.rates = this.querySelector('.js-rates');
      this.errors = this.querySelector('.js-errors');
      this.initialised = true;
    }

    setupEventListeners() {
      this.zip.addEventListener('keydown', this.handleZipKeydown.bind(this));
      this.button.addEventListener('click', this.handleSubmit.bind(this));
    }

    setupZipMask() {
      this.zip.addEventListener('input', (e) => {
        let value = e.target.value.replace(/\D/g, '');
        if (value.length > 5) {
          value = value.slice(0, 5) + '-' + value.slice(5, 8);
        }
        e.target.value = value;
      });
    }

    detectStateFromZip(zip) {
      const cleanZip = zip.replace(/\D/g, '');
      const firstDigit = parseInt(cleanZip[0]);
      
      // Mapeamento de CEP para estados brasileiros
      const stateMap = {
        0: 'SP', // 01000-000 a 09999-999
        1: 'SP', // 10000-000 a 19999-999
        2: 'RJ', // 20000-000 a 28999-999
        3: 'MG', // 30000-000 a 39999-999
        4: 'BA', // 40000-000 a 48999-999
        5: 'PE', // 50000-000 a 56999-999
        6: 'CE', // 60000-000 a 63999-999
        7: 'DF', // 70000-000 a 76999-999
        8: 'PR', // 80000-000 a 87999-999
        9: 'RS'  // 90000-000 a 99999-999
      };
      
      // Para CEPs específicos, refinar o estado
      if (firstDigit === 2 && parseInt(cleanZip.slice(0, 2)) >= 29) {
        return 'ES'; // 29000-000 a 29999-999
      }
      if (firstDigit === 5 && parseInt(cleanZip.slice(0, 2)) >= 57) {
        return 'PE'; // Recife e região
      }
      if (firstDigit === 6 && parseInt(cleanZip.slice(0, 2)) >= 64) {
        if (parseInt(cleanZip.slice(0, 2)) <= 64) return 'PI';
        if (parseInt(cleanZip.slice(0, 2)) <= 65) return 'MA';
        if (parseInt(cleanZip.slice(0, 2)) <= 68) return 'PA';
        if (parseInt(cleanZip.slice(0, 2)) === 69) return 'AM';
      }
      if (firstDigit === 7 && parseInt(cleanZip.slice(0, 2)) >= 77) {
        if (parseInt(cleanZip.slice(0, 2)) <= 77) return 'GO';
        if (parseInt(cleanZip.slice(0, 2)) === 78) return 'MT';
        if (parseInt(cleanZip.slice(0, 2)) === 79) return 'MS';
      }
      if (firstDigit === 8 && parseInt(cleanZip.slice(0, 2)) >= 88) {
        return 'SC'; // 88000-000 a 89999-999
      }
      
      return stateMap[firstDigit] || 'SP'; // Default para SP
    }

    async handleSubmit(evt) {
      if (evt) evt.preventDefault();
      
      // Inicializar elementos se necessário
      if (!this.initialised) this.init();
      
      const zipValue = this.zip.value.replace(/\D/g, '');
      
      // Validar CEP
      if (zipValue.length !== 8) {
        this.showErrors({ zip: ['CEP inválido. Digite 8 números.'] });
        return;
      }

      this.errors.hidden = true;
      this.rates.hidden = true;
      this.button.disabled = true;
      this.button.classList.add('is-loading');
      this.button.textContent = 'Calculando...';

      // Detectar estado baseado no CEP
      const state = this.detectStateFromZip(zipValue);
      this.province.value = state;

      try {
        // No carrinho, não precisamos adicionar produto temporário
        // pois já existem itens no carrinho
        const params = `shipping_address[zip]=${zipValue}&shipping_address[country]=Brazil&shipping_address[province]=${state}`;
        const response = await fetch(`${theme.routes.cart}/shipping_rates.json?${params}`);
        const data = await response.json();

        if (response.ok) {
          this.showRates(data);
        } else {
          this.showErrors(data);
        }
      } catch (error) {
        console.error('Erro ao calcular frete:', error);
        this.showErrors({ general: ['Erro ao calcular o frete. Tente novamente.'] });
      } finally {
        this.button.classList.remove('is-loading');
        this.button.disabled = false;
        this.button.textContent = 'Calcular frete';
      }
    }

    handleZipKeydown(evt) {
      if (evt.key === 'Enter') {
        evt.preventDefault();
        this.handleSubmit();
      }
    }




    showRates(data) {
      const headingEl = this.rates.querySelector('.js-rates-heading');
      const textEl = this.rates.querySelector('.js-rates-text');
      textEl.innerHTML = '';

      if (data.shipping_rates && data.shipping_rates.length) {
        const headingText = data.shipping_rates.length === 1 ? 
          'Opção de entrega disponível:' : 
          'Opções de entrega disponíveis:';
        
        let rates = '';
        data.shipping_rates.forEach((rate) => {
          const formattedRate = theme.settings.moneyWithCurrencyFormat.replace(/\{\{\s*(\w+)\s*\}\}/, rate.price);
          
          // Calcular prazo de entrega a partir das datas
          let deliveryTime = '';
          
          if (rate.delivery_range && Array.isArray(rate.delivery_range) && rate.delivery_range.length === 2) {
            const today = new Date();
            today.setHours(0, 0, 0, 0); // Zerar horas para comparação correta
            
            const minDate = new Date(rate.delivery_range[0]);
            const maxDate = new Date(rate.delivery_range[1]);
            
            // Calcular diferença em dias
            const minDays = Math.ceil((minDate - today) / (1000 * 60 * 60 * 24));
            const maxDays = Math.ceil((maxDate - today) / (1000 * 60 * 60 * 24));
            
            if (minDays === maxDays) {
              deliveryTime = `<br><span style="color: #666; font-size: 0.9em; font-weight: normal;">${minDays} dias úteis</span>`;
            } else if (minDays > 0 && maxDays > 0) {
              deliveryTime = `<br><span style="color: #666; font-size: 0.9em; font-weight: normal;">${minDays} a ${maxDays} dias úteis</span>`;
            }
          }
          // Fallback: se vier como string já formatada
          else if (rate.delivery_days && typeof rate.delivery_days === 'string') {
            deliveryTime = `<br><span style="color: #666; font-size: 0.9em; font-weight: normal;">${rate.delivery_days}</span>`;
          }
          
          rates += `<li style="margin-bottom: 0.75rem;"><strong>${rate.name}:</strong> ${formattedRate}${deliveryTime}</li>`;
        });

        headingEl.hidden = false;
        headingEl.textContent = headingText;
        textEl.innerHTML = `<ul class="styled-list">${rates}</ul>`;
      } else {
        headingEl.hidden = true;
        textEl.innerHTML = 'Não há opções de entrega disponíveis para este CEP.';
      }

      this.rates.hidden = false;
    }




    showErrors(data) {
      let errors = '';
      Object.keys(data).forEach((key) => {
        if (Array.isArray(data[key])) {
          data[key].forEach(error => {
            errors += `<li>${error}</li>`;
          });
        } else {
          errors += `<li>${data[key]}</li>`;
        }
      });

      this.errors.querySelector('.js-errors-text').innerHTML = `<ul class="styled-list">${errors}</ul>`;
      this.errors.hidden = false;
    }
  }

  customElements.define('shipping-calculator-cart-brazil', ShippingCalculatorCartBrazil);
}